<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<template>
  <div class="intro-wrapper">
    <div class="intro-container">
      <div class="intro-content">
        <h1>{{ t('new_customer.title') }}</h1>
        <p v-html="t('new_customer.intro')"></p>
      </div>
      <div class="intro-img">
        <img src="../assets/img/hand.png" alt="intro" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.intro-wrapper {
  background-color: #efedea;
  padding: 0 0;
}

.intro-container {
  display: flex;
  justify-content: space-between;
  max-width: 1126px;
  margin: 0 auto;
}

.intro-content {
  width: 60%;
  padding-top: 80px;
  display: flex;
  flex-direction: column;
}

h1 {
  max-width: 695px;
  line-height: 63px;
}

p {
  font-size: 24px;
  line-height: 33px;
  max-width: 555px;
}

.intro-img {
  width: 525px;
  height: auto;
}

.intro-img img {
  width: 100%;
  height: auto;
  display: block;
}

@media only screen and (max-width: 768px) {
  .intro-container {
    flex-direction: column;
    align-items: center;
  }

  .intro-content {
    max-width: 260px;
  }

  h1 {
    font-size: 42px;
    line-height: 40px;
    text-align: center;
  }

  p {
    font-size: 14px;
    line-height: 19px;
    text-align: center;
  }

  .intro-img {
    max-width: 326px;
    max-height: 411px;
  }
}

@media only screen and (max-width: 992px) {
  .intro {
    padding: 0;
  }

  .intro-container {
    flex-direction: column;
    align-items: center;
  }

  .intro-content {
    width: 100%;
    padding: 0;
    text-align: center;
    align-items: center;
  }
}

@media only screen and (max-width: 1200px) {
  .intro-container {
    padding: 40px 15px 0 0;
  }

  .intro-content {
    padding: 0 0 0 30px;
  }
}
</style>
